import { ratingQuestionTemplate } from "./utils";
import { loc } from "../i18n/survey";

const dissatisfactionQuestion = {
  ...ratingQuestionTemplate,
  name: 'dissatisfaction',
  title: loc("quiz.rating.title"),
  description: loc("quiz.dissatisfaction.statement"),
};

export {
  dissatisfactionQuestion,
}